// itk-wasm WebWorker API interfaces, data structures, and functions
export { default as WorkerPool } from './worker-pool.js';
//# sourceMappingURL=index.js.map